import React from 'react';
import { TextField } from '@mui/material';
import { useStatsTheme } from '../../v2/theme/statsTheme';

/**
 * TextField style v2 : fond floating, border discret, focus accent club.
 * Passe-plat sur toutes les props MUI TextField.
 */
export default function CanteraTextField({ tone = 'dark', sx = {}, ...props }) {
  const theme = useStatsTheme();
  const isDark = tone === 'dark';

  const bg = isDark ? theme.surfaces.floating : '#FFFFFF';
  const fg = isDark ? theme.text.primary : '#111827';
  const fgSecondary = isDark ? theme.text.secondary : '#6B7280';
  const border = isDark ? theme.surfaces.border : 'rgba(0,0,0,0.16)';

  return (
    <TextField
      variant="outlined"
      {...props}
      sx={{
        '& .MuiOutlinedInput-root': {
          bgcolor: bg,
          color: fg,
          borderRadius: `${theme.radius.md}px`,
          transition: theme.motion.fast,
          '& fieldset': { borderColor: border },
          '&:hover fieldset': { borderColor: theme.accentBorder },
          '&.Mui-focused fieldset': {
            borderColor: theme.accent,
            borderWidth: 2,
          },
        },
        '& .MuiInputLabel-root': {
          color: fgSecondary,
          '&.Mui-focused': { color: theme.accent },
        },
        '& .MuiFormHelperText-root': { color: fgSecondary },
        ...sx,
      }}
    />
  );
}
